module.exports = __webpack_public_path__ + "img/3.160a6d0d.jpg";